export const ListQueryKey = 'ActivityQhReward';
export const DetailQueryKey = 'activityRecommendRecord';
export const Urls = {
  selectUrl: '/QhRecord/list',
  updateUrl: '/QhRecord/update',
  deleteUrl: '/QhRecord/delete',
  createUrl: '/QhRecord/create',
  detailUrl: '/QhRecord/info'
};